<div class="download-progress-container" [ngClass]="{'has-promotion': hasPromotion && !device.isMobile}">
    <div class="circular-progress-container">
        <div class="logo-safe-container">
            <app-smash-circular-progress></app-smash-circular-progress>
        </div>
    </div>
    <div class="download-progress-body">
        <div class="download-status-container">
            <div class="download-progress-status" [innerHtml]="'MODAL_DOWNLOADER_TITLE' | translate | safeHtml"></div>
            <div *ngIf="isMainDomain" class="download-progress-description" translate [innerHtml]="'MODAL_DOWNLOADER_FREEMIUM_DESCRIPTION' | translate | safeHtml"></div>
            <div *ngIf="!isMainDomain" class="download-progress-description" translate [innerHtml]="'MODAL_DOWNLOADER_PREMIUM_DESCRIPTION' | translate | safeHtml"></div>
        </div>
        <div class="download-footer">
            <div class="download-footer-wrapper">
                <button class="btn light"
                    (click)="backToPreview()">{{ 'MODAL_DOWNLOADER_BUTTON_LABEL_BACK' | translate }}</button>
            </div>
        </div>
    </div>
</div>